export default "__VITE_ASSET__xWdIGJs5__"